var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFour(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#3240DD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7891 14.7676V14.0176H9.86523C9.26758 14.0176 8.9043 13.6953 8.9043 13.1504C8.9043 12.8926 8.97461 12.6641 9.19141 12.2246C9.85938 10.959 10.4863 9.89258 11.5293 8.35156C12.0215 7.63672 12.3965 7.39062 13.0059 7.39062C13.7969 7.39062 14.2715 7.8125 14.2715 8.50977V12.7285H14.6641C15.0859 12.7285 15.3438 12.9863 15.3438 13.3848C15.3438 13.7773 15.0918 14.0176 14.6641 14.0176H14.2715V14.7676C14.2715 15.2656 13.9902 15.5703 13.5273 15.5703C13.0645 15.5703 12.7891 15.2656 12.7891 14.7676ZM10.3516 12.7285H12.7891V8.75H12.707C12.0039 9.81641 10.8672 11.7559 10.3516 12.6875V12.7285Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFour);
export default __webpack_public_path__ + "static/media/four.b7d58cfb7608a6be7a67101fa19420f3.svg";
export { ForwardRef as ReactComponent };